import { getCalcInputState } from '../../../../../utils/selectors'
import { formSlice } from './slice'

export const getFormState = (state) => getCalcInputState(state)[formSlice.name]
export const getFormErrors = (state) => getFormState(state).errors
export const getFormValid = (state) => getFormState(state).isValid
